<div class="users-list-page page-container">
  <div class="page-header">
    <h1 class="page-title">Listado de Usuarios</h1>
    <p class="page-subtitle">
      Gestiona y monitorea todas las asociaciones comerciales activas y la distribución de
      comisiones.
    </p>
  </div>

  <div class="toolbar">
    <div class="search-wrapper">
      <fa-icon [icon]="faMagnifyingGlass" class="search-icon"></fa-icon>
      <input
        type="text"
        placeholder="Buscar usuarios..."
        (input)="onSearch($event.target.value)"
        class="search-input app-input"
      />
    </div>

    <div class="toolbar-actions">
      <!-- <button class="btn-filter">
        <fa-icon [icon]="faSliders" class="filter-icon"></fa-icon>
        Filtros
      </button>
      <button class="btn-export">
        <fa-icon [icon]="faDownload" class="export-icon"></fa-icon>
        Exportar
      </button> -->
      <a routerLink="/admin/users/new" class="app-btn app-btn--primary">
        <fa-icon [icon]="faPlus"></fa-icon>
        Añadir Usuario
      </a>
    </div>
  </div>

  @if (error) {
    <div class="error-message">
      {{ error }}
    </div>
  }

  <div
    class="users-table-wrapper"
    (scroll)="onScroll($event)"
    style="max-height: calc(100vh - 220px)"
  >
    @if (isLoading) {
      <div class="loading-state">
        <div class="loading-spinner"></div>
        <p>Cargando usuarios...</p>
      </div>
    } @else if (users.length === 0) {
      <div class="empty-state">
        <p>No se encontraron usuarios</p>
      </div>
    } @else {
      <table class="users-table">
        <thead>
          <tr>
            <th class="sortable" (click)="onSort('name')">
              <div class="header-content">
                <span>Nombre</span>
                <fa-icon
                  [icon]="getSortIcon('name')"
                  class="sort-icon"
                  [class.active]="sortBy === 'name'"
                ></fa-icon>
              </div>
            </th>
            <th class="sortable" (click)="onSort('company')">
              <div class="header-content">
                <span>Partner</span>
                <fa-icon
                  [icon]="getSortIcon('company')"
                  class="sort-icon"
                  [class.active]="sortBy === 'company'"
                ></fa-icon>
              </div>
            </th>
            <th class="sortable" (click)="onSort('email')">
              <div class="header-content">
                <span>Email</span>
                <fa-icon
                  [icon]="getSortIcon('email')"
                  class="sort-icon"
                  [class.active]="sortBy === 'email'"
                ></fa-icon>
              </div>
            </th>
            <th class="sortable" (click)="onSort('type')">
              <div class="header-content">
                <span>Tipo</span>
                <fa-icon
                  [icon]="getSortIcon('type')"
                  class="sort-icon"
                  [class.active]="sortBy === 'type'"
                ></fa-icon>
              </div>
            </th>

            <th class="sortable" (click)="onSort('active')">
              <div class="header-content">
                <span>Estado</span>
                <fa-icon
                  [icon]="getSortIcon('active')"
                  class="sort-icon"
                  [class.active]="sortBy === 'active'"
                ></fa-icon>
              </div>
            </th>

            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          @for (user of users; track user.id) {
            <tr>
              <td class="partner-cell">
                <div class="avatar">{{ user.name.charAt(0).toUpperCase() || '?' }}</div>
                <span class="partner-name">{{ user.name }}</span>
              </td>
              <td class="company-cell">
                @if (user.partner) {
                  <a [routerLink]="['/admin/partners', user.partner.id]" class="partner-link">
                    {{ user.partner.company_name }}
                  </a>
                } @else {
                  <span>-</span>
                }
              </td>
              <td class="email-cell">{{ user.email }}</td>
              <td class="type-cell text-xs text-gray-500 font-medium">
                {{ user.type || '-' }}
              </td>

              <td>
                <span
                  class="stage-badge"
                  [ngClass]="user.active ? 'stage-active' : 'stage-inactive'"
                >
                  {{ user.active ? 'Activo' : 'Inactivo' }}
                </span>
              </td>

              <td class="actions-cell">
                <div class="actions-menu-wrapper">
                  <button
                    type="button"
                    class="btn-actions"
                    (click)="toggleMenu(user.id, $event)"
                    aria-label="Acciones"
                  >
                    <fa-icon [icon]="faEllipsisVertical"></fa-icon>
                  </button>
                  @if (openMenuId === user.id && menuPosition) {
                    <div
                      class="dropdown-menu"
                      [style.top.px]="menuPosition.top"
                      [style.left.px]="menuPosition.left"
                    >
                      <a
                        [routerLink]="['/admin/users', user.id]"
                        class="dropdown-item"
                        (click)="closeMenu()"
                      >
                        <fa-icon [icon]="faPen" class="dropdown-icon"></fa-icon>
                        Editar
                      </a>
                      <button
                        type="button"
                        class="dropdown-item"
                        (click)="toggleActive(user.id); closeMenu()"
                      >
                        <fa-icon
                          [icon]="user.active ? faToggleOff : faToggleOn"
                          class="dropdown-icon"
                        ></fa-icon>
                        {{ user.active ? 'Desactivar' : 'Activar' }}
                      </button>
                      <button
                        type="button"
                        class="dropdown-item"
                        (click)="sendInvitation(user.id); closeMenu()"
                      >
                        <fa-icon [icon]="faPaperPlane" class="dropdown-icon"></fa-icon>
                        Enviar invitación
                      </button>
                      <button
                        type="button"
                        class="dropdown-item danger"
                        (click)="deleteUser(user.id); closeMenu()"
                      >
                        <fa-icon [icon]="faTrash" class="dropdown-icon"></fa-icon>
                        Eliminar
                      </button>
                    </div>
                  }
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
      @if (isLoadingMore) {
        <div class="infinite-loader">
          <div class="loading-spinner small"></div>
          <p>Cargando...</p>
        </div>
      }
    }
  </div>
</div>
